__turbopack_context__.v({
  "bannerImage": "BannerImage-module-scss-module__UCBtAa__bannerImage",
  "bannerImageRoot": "BannerImage-module-scss-module__UCBtAa__bannerImageRoot",
});
